import { all, fork, call, put, takeLatest } from 'redux-saga/effects'

import { constants } from '../../modules/jobFunctions/jobInvoiceActions'
import * as api from '../../api/job/invoices'
import { omit } from 'lodash'

function* jobInvoicesRefresh(action) {
  try {
    let payload = []
    if (action.fromDashboard) {
      const assignedToId = action.assignedToId ? action.assignedToId : 0
      payload = yield call(api.getDashboardInvoices, assignedToId)
    } else {
      payload = yield call(api.getJobInvoices, action.jobId)
    }
    yield put({ type: constants.JOB_INVOICES_REFRESH.SUCCESS, payload })
    action.next && action.next(payload)
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.JOB_INVOICES_REFRESH.FAILED,
      message: e.message || e
    })
  }
}

function* watchJobInvoices() {
  yield takeLatest(constants.JOB_INVOICES_REFRESH.ACTION, jobInvoicesRefresh)
}

function* sagaCreateJobInvoice(action) {
  try {
    const payload = {
      job_id: action.jobId,
      content: action.content
    }

    payload.content.created_by_id = action.userId
    payload.content.updated_by_id = action.userId
    payload.content.assigned_to_id = action.userId
    payload.content.job_id = action.jobId

    yield call(api.createJobInvoice, payload)
    yield put({ type: constants.JOB_INVOICE_CREATE.SUCCESS, payload })
    yield call(jobInvoicesRefresh, { jobId: action.jobId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.JOB_INVOICE_CREATE.FAILED,
      message: e.message || e
    })
  }
}

function* watchCreateJobInvoice() {
  yield takeLatest(constants.JOB_INVOICE_CREATE.ACTION, sagaCreateJobInvoice)
}

function* sagaUpdateJobInvoice(action) {
  try {
    const payload = {
      job_invoice_id: action.invoiceId,
      content: omit(action.content, ['files'])
    }

    payload.content.updated_by_id = action.userId
    payload.content.job_id = action.jobId

    yield call(api.updateJobInvoice, payload)
    yield put({ type: constants.JOB_INVOICE_UPDATE.SUCCESS, payload })
    yield call(jobInvoicesRefresh, {
      jobId: action.jobId,
      fromDashboard: action.content.fromDashboard,
      assignedToId: action.content.selectedUser
    })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.JOB_INVOICE_UPDATE.FAILED,
      message: e.message || e
    })
  }
}

function* watchUpdateJobInvoice() {
  yield takeLatest(constants.JOB_INVOICE_UPDATE.ACTION, sagaUpdateJobInvoice)
}

function* sagaDeleteJobInvoice(action) {
  try {
    const payload = {
      job_invoice_id: action.invoiceId
    }
    yield call(api.deleteJobInvoice, payload)
    yield put({ type: constants.JOB_INVOICE_DELETE.SUCCESS, payload })
    yield call(jobInvoicesRefresh, { jobId: action.jobId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.JOB_INVOICE_DELETE.FAILED,
      message: e.message || e
    })
  }
}

function* watchDeleteJobInvoice() {
  yield takeLatest(constants.JOB_INVOICE_DELETE.ACTION, sagaDeleteJobInvoice)
}

// ATTACHMENT SAGAS
function* uploadAttachments(action) {
  try {
    const payload = {
      formData: action.formData,
      invoiceId: action.invoiceId
    }

    yield call(api.uploadAttachments, payload)
    yield put({ type: constants.UPLOAD_INVOICE_ATTACHMENT.SUCCESS, payload })
    yield call(getAttachments, { invoiceId: action.invoiceId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.UPLOAD_INVOICE_ATTACHMENT.FAILED,
      message: e.message || e
    })
  }
}

function* watchUploadAttachments() {
  yield takeLatest(constants.UPLOAD_INVOICE_ATTACHMENT.ACTION, uploadAttachments)
}

function* getAttachments(action) {
  try {
    const payload = yield call(api.getAttachments, action.invoiceId)
    yield put({ type: constants.GET_INVOICE_ATTACHMENTS.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.GET_INVOICE_ATTACHMENTS.FAILED,
      message: e.message || e
    })
  }
}

function* watchGetAttachments() {
  yield takeLatest(constants.GET_INVOICE_ATTACHMENTS.ACTION, getAttachments)
}

function* updateAttachmentDescription(action) {
  try {
    const payload = {
      attachmentId: action.attachmentId,
      created_by_id: action.userId,
      updated_by_id: action.userId,
      user_id: 1,
      description: action.description
    }
    yield call(api.updateAttachmentDescription, payload)
    yield put({ type: constants.UPDATE_INVOICE_ATTACHMENT_DESCRIPTION.SUCCESS, payload })
    yield call(getAttachments, { invoiceId: action.invoiceId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.UPDATE_INVOICE_ATTACHMENT_DESCRIPTION.FAILED,
      message: e.message || e
    })
  }
}

function* watchUpdateAttachmentDescription() {
  yield takeLatest(
    constants.UPDATE_INVOICE_ATTACHMENT_DESCRIPTION.ACTION,
    updateAttachmentDescription
  )
}

function* deleteAttachment(action) {
  try {
    const payload = {
      attachmentId: action.attachmentId,
      invoiceId: action.invoiceId
    }

    yield call(api.deleteAttachment, payload)
    yield put({ type: constants.DELETE_INVOICE_ATTACHMENT.SUCCESS, payload })
    yield call(getAttachments, { invoiceId: action.invoiceId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.DELETE_INVOICE_ATTACHMENT.FAILED,
      message: e.message || e
    })
  }
}

function* watchDeleteAttachments() {
  yield takeLatest(constants.DELETE_INVOICE_ATTACHMENT.ACTION, deleteAttachment)
}

export function* rootSaga() {
  // add more sagas here
  yield all([
    fork(watchJobInvoices),

    fork(watchCreateJobInvoice),
    fork(watchUpdateJobInvoice),
    fork(watchDeleteJobInvoice),

    fork(watchUploadAttachments),
    fork(watchGetAttachments),
    fork(watchUpdateAttachmentDescription),
    fork(watchDeleteAttachments)
  ])
}



// WEBPACK FOOTER //
// ./src/redux/sagas/jobFunctions/jobInvoiceSaga.js